import Queue from 'promise-queue'

const maxConcurrent = 5;
const maxQueue = Number.MAX_SAFE_INTEGER;
const queue = new Queue(maxConcurrent, maxQueue);

const request = (...args) => {
    return queue.add(() => {
        return fetch(...args)
    })
}

export default request;


// WEBPACK FOOTER //
// ./src/services/request.js